export const IconShrink = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M9.778 15.34c0-.611-.5-1.111-1.11-1.111H4.224c-.61 0-1.11.5-1.11 1.11 0 .612.5 1.112 1.11 1.112h1.767l-3.655 3.657a1.107 1.107 0 1 0 1.566 1.567l3.655-3.657v1.768c0 .61.5 1.111 1.11 1.111.612 0 1.111-.5 1.111-1.111zM19.776 14.229h-4.444c-.61 0-1.11.5-1.11 1.11v4.447c0 .61.5 1.111 1.11 1.111s1.111-.5 1.111-1.111v-1.768l3.655 3.657a1.107 1.107 0 1 0 1.566-1.567l-3.655-3.657h1.767c.61 0 1.11-.5 1.11-1.111s-.5-1.111-1.11-1.111M2.325 2.325a1.12 1.12 0 0 0 0 1.578L5.979 7.56H4.213c-.61 0-1.11.5-1.11 1.111 0 .612.5 1.112 1.11 1.112h4.443c.611 0 1.111-.5 1.111-1.112V4.226c0-.612-.5-1.112-1.11-1.112s-1.111.5-1.111 1.112v1.767L3.902 2.325a1.12 1.12 0 0 0-1.577 0M21.675 2.325a1.106 1.106 0 0 0-1.566 0l-3.655 3.657V4.215c0-.612-.5-1.112-1.11-1.112s-1.111.5-1.111 1.112V8.66c0 .611.5 1.112 1.11 1.112h4.444c.61 0 1.11-.5 1.11-1.112 0-.611-.5-1.111-1.11-1.111H18.02l3.655-3.657a1.107 1.107 0 0 0 0-1.567"
        clipRule="evenodd"
      />
    </svg>
  );
};
